import { render } from "./PromoGame.vue?vue&type=template&id=28c7ae2a&scoped=true"
import script from "./PromoGame.vue?vue&type=script&lang=js"
export * from "./PromoGame.vue?vue&type=script&lang=js"

import "./PromoGame.vue?vue&type=style&index=0&id=28c7ae2a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c7ae2a"]])

export default __exports__